import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomainCompactInfo } from '@app/core/interfaces/c5/domain-compact-info';
import { UserLevel } from '@app/core/models/user-level';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { mergeMap, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SystemRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  listServiceProviders(): Observable<DomainCompactInfo[]> {
    return this.utils.routeBasedApiUrl('/serviceProviders', UserLevel.SystemAdmin).pipe(
      mergeMap((url) => this.http.get<DomainCompactInfo[]>(url)),
      wrapError('system-repository:list-service-providers')
    );
  }
}
